import './index.scss';

import React, { useState, useCallback, useEffect } from 'react';
import _ from 'lodash';
import Axios from '@/axiosPool';
import FieldType from './Fields/Type/Type';
import FieldName from './Fields/Name/Name';
import FieldProjectLead from './Fields/ProjectLead/ProjectLead';
import FieldColor from './Fields/Color/Color';
import ModalPortal from '@/components/common/Modal/ModalPortal';
import useForm from '@/hooks/useForm';
import ConfirmCreation from '../../../Common/Modals/ConfirmCreation/ConfirmCreation';
import EmailInput from '@/components/project/Common/Form/EmailInput/EmailInput';
import { saveCompanyForm, confirmationModal } from './Config';
import { useToggle } from '@/hooks/useToggle';
import { getSuggested } from '@/util/email';
import { EMAIL_SUFFIX } from '@/components/project/Config/Config';
import { showToast } from '@/globalFunction';
import { connect } from 'react-redux';
import EmailInputContainer from '../../../Common/Form/EmailInput/EmailInputContainer';

@connect((store) => {
  return {
    loggedUser: store.loggedUser,
    project: store.project,
  };
})
class AddCompany extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      name: null,
      selected: {},
      color: null,
      typeId: {},
      isClose: false,
    };

    this.formRef = React.createRef();

    _.map(
      [
        'onSave',
        'onSelectLead',
        'onInputChange',
        'onChangeColor',
        'onSetProjectType',
        'onClose',
        'onLeadOpen',
      ],
      (fn) => {
        this[fn] = this[fn].bind(this);
      }
    );
  }

  componentDidUpdate(prevProps) {
    const { confirmSubmit } = this.props;

    if (confirmSubmit && !_.isEqual(prevProps.confirmSubmit, confirmSubmit)) {
      this.onSave();
      this.onClose();
    }
  }

  onSave() {
    const { dispatch, loggedUser, fieldEmail } = this.props;
    const url = 'api/project';
    const params = {
      color: this.state.color,
      createdBy: loggedUser.data.id,
      project: this.state.name,
      projectManagerId: this.state.selected.value,
      email: fieldEmail.value,
      typeId: this.state.typeId.value ? this.state.typeId.value : 1,
    };

    dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });

    Axios.post(url, params, { timeout: 10000 })
      .then((response) => {
        if (response) {
          window.location.replace(
            `/account#/projects/${response.data.project.id}/?new=1`
          );

          dispatch({ type: 'SET_PROJECT_NEWLY_ADDED', boolean: true });

          this.onClose();
        }

        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
      })
      .catch((e) => {
        console.error(e);
        showToast('error', 'Something went wrong please try again later.');
        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
      });
  }

  onSelectLead(option) {
    this.setState({
      ...this.state,
      selected: option ? option : {},
    });
  }

  onInputChange(e) {
    const { setAccountName, setAccountNameTouched } = this.props;

    this.setState({
      ...this.state,
      name: e.name,
      error: e.error || false,
    });

    setAccountName(e.name);
    setAccountNameTouched(true);
  }

  onChangeColor(e) {
    this.setState({
      ...this.state,
      color: e.hex,
    });
  }

  onSetProjectType(e) {
    const { loggedUser } = this.props;
    this.setState({
      ...this.state,
      typeId: e,
      ...(e.value === 3
        ? {
            selected: {
              value: loggedUser.data.id,
              label: `${loggedUser.data.firstName} ${loggedUser.data.lastName}`,
            },
          }
        : {}),
    });
  }

  onClose() {
    const { resetHookState } = this.props;

    resetHookState();
    this.formRef.current.reset();
    this.setState(
      {
        error: false,
        name: null,
        selected: {},
        color: null,
        typeId: {},
        isClose: true,
      },
      () => {
        $('#addCompanyModal').modal('hide');
      }
    );
  }

  onLeadOpen() {
    this.setState({
      ...this.state,
      isClose: false,
    });
  }

  render() {
    const { project, fieldEmail, setShowConfirmModal } = this.props;
    const { props: fieldEmailProps } = fieldEmail;
    const isButtonDisabled =
      !this.state.name ||
      !this.state.selected.value ||
      !this.state.color ||
      this.state.error ||
      !fieldEmailProps.valid ||
      !fieldEmailProps.value ||
      (project.AddType === 'project' && !this.state.typeId.value);

    return (
      <div
        class="modal fade bg-overlay add-modal"
        data-backdrop="static"
        data-keyboard="false"
        id="addCompanyModal"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bb">
              <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10">
                  <p class="modalTitle">
                    Add New{' '}
                    {project.AddType === 'company' ? 'Company' : 'Project'}
                  </p>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2">
                  <a
                    class="text-right text-black"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.onClose}
                  >
                    <i class="material-icons text-white text-size22">close</i>
                  </a>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <label class="requiredNote">
                (<sup>*</sup>) Indicates a required field
              </label>
              <form ref={this.formRef}>
                <FieldType
                  selected={this.state.typeId}
                  onSetProjectType={this.onSetProjectType}
                />
                <FieldName
                  name={this.state.name}
                  error={this.state.error}
                  onInputChange={this.onInputChange}
                />
                <FieldProjectLead
                  typeId={this.state.typeId}
                  selected={this.state.selected}
                  onSelectLead={this.onSelectLead}
                  onLeadOpen={this.onLeadOpen}
                  isClose={this.state.isClose}
                />
                <FieldColor
                  color={this.state.color}
                  onChangeColor={this.onChangeColor}
                />
                <EmailInputContainer
                  label="Account Email"
                  errorMessage={fieldEmailProps.errorMessage}
                  valid={fieldEmailProps.valid}
                >
                  <EmailInput
                    name="email"
                    placeholder="Account Email"
                    {...fieldEmailProps}
                  />
                </EmailInputContainer>
              </form>
            </div>
            <div class="modal-footer">
              <div class="modalActions">
                <button
                  type="button"
                  class={`btn btn-secondary btn-cancel`}
                  data-dismiss="modal"
                  onClick={this.onClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class={`btn btn-create ${isButtonDisabled ? 'disabled' : ''}`}
                  onClick={() => setShowConfirmModal(true)}
                >
                  Create Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const withHooks = (Component) => (props) => {
  const { registerFormInput, resetForm, setFormFieldValue } = useForm({
    validationRules: saveCompanyForm.email.validationRules,
  });
  const [showConfirmModal, setShowConfirmModal] = useToggle(false);
  const [confirmSubmit, setConfirmSubmit] = useState(false);
  const [accountName, setAccountName] = useState('');
  const [accontNameTouched, setAccountNameTouched] = useState(false);

  const fieldEmailProps = registerFormInput('email');
  const fieldEmail = {
    props: fieldEmailProps,
    value: `${fieldEmailProps.value}@${EMAIL_SUFFIX}`,
  };

  useEffect(() => {
    if (!accontNameTouched) {
      return;
    }

    const suggestedEmail = getSuggested(accountName);
    setFormFieldValue('email', suggestedEmail);

    if (accountName) {
      fieldEmailProps.onValidate({
        target: {
          name: 'email',
          value: suggestedEmail,
        },
      });
    }
  }, [accountName, accontNameTouched]);

  const submitForm = useCallback(() => {
    setShowConfirmModal(false);
    setConfirmSubmit(true);
  }, []);

  const resetHookState = useCallback(() => {
    setShowConfirmModal(false);
    setConfirmSubmit(false);
    setAccountName('');
    setAccountNameTouched(false);
    resetForm();
  }, [fieldEmail]);

  return (
    <React.Fragment>
      <Component
        {...props}
        fieldEmail={fieldEmail}
        setAccountName={setAccountName}
        showConfirmModal={showConfirmModal}
        setShowConfirmModal={setShowConfirmModal}
        confirmSubmit={confirmSubmit}
        resetHookState={resetHookState}
        setAccountNameTouched={setAccountNameTouched}
      />
      {showConfirmModal && (
        <ModalPortal>
          <ConfirmCreation
            title={confirmationModal.title}
            body={confirmationModal.body(accountName, fieldEmail.value)}
            onClose={() => setShowConfirmModal(false)}
            onConfirm={submitForm}
          />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default withHooks(AddCompany);
